import React from 'react';

import './InsuranceOffer.scss';

export default function InsuranceOffer(props) {
  return (
    <div className="insuranceOffer">
      <h4 className="insuranceOffer-title">
        De beste aanvullende zorgverzekering voor tijdens en na je zwangerschap
      </h4>

      <div className="insuranceOffer-logo-wrap">
        <h5 className="insuranceOffer-subtitle">
          Basisverzekering Basis Keuze + Aanvullend ZorgZeker 2
        </h5>

        <img
          className="insuranceOffer-logo"
          className="insuranceOffer-logo"
          src="https://upr.io/db2myd.png"
        />
      </div>

      <ul className="insuranceOffer-list">
        <li>
          Ziekenhuisbevalling (zonder medische indicatie): volledig vergoed
        </li>
        <li>Eigen bijdrage kraamzorg: € 125,00</li>
        <li>Kraampakket: gratis</li>
        <li>Lactatiekundige: € 200,00</li>
        <li>Huur/aanschaf borstkolf: € 80,00</li>
        <li>Fysiotherapie: 12 behandelingen</li>
        <li>EHBO- of reanimatiecursus: € 500,00</li>
        <li>Zwangerschapscursus (toegang tot cursusportaal Basis pakket): € 100,00</li>
        <li className="bold">Overige vergoedingen:</li>
        <li>Vruchtbaarheidsbehandelingen geen</li>
        <li>
          Leefstijladvies/interventie voor bijv. gewichtsverlies
          Gewichtsconsulent: €100
        </li>
        <li>Preventie: €500</li>
        <li>Alternatieve geneeswijzen € 250,00</li>
        <li>Tandongevallenverzekering tot € 20,000</li>
        <li>Deelnemer bespaart jaalijks extra € 140,00</li>
        <li>Altijd 14 dagen bedenktijd- Uitstekende service beoordeeld met 9,1</li>
        <li className="bold">
          Je bent compleet verzekerd voor € 175.85 per maand
        </li>
      </ul>

      <a
        target="_blank"
        rel="noopener noreferrer"
        className="insuranceOffer-button"
        href="https://www.unitedconsumers.com/zorgverzekering/?cid=zwangerenportaal&sid=kalenderweken&utm_source=zwangerenportaal&utm_medium=partner&utm_campaign=zorgcampagne_2025&utm_content=zorg"
      >
        Kies dit pakket
      </a>
    </div>
  );
}
